export enum ExternalWizardEventType {
	documentationClicked = 'documentation-clicked',
	submitApplicationClicked = 'submit-application-clicked',
	customFieldAdded = 'custom-field-added'
}
